<template>
  <div class="my-appointment-page">
    <van-nav-bar title="我的预约" left-arrow @click-left="onClickLeft" />

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadData">
        <div v-if="list.length === 0 && !loading" class="empty">
          <van-icon name="notes-o" size="60" color="#ddd" />
          <p>暂无预约记录</p>
        </div>

        <div v-for="item in list" :key="item.appointmentId" class="appointment-item" @click="goDetail(item)">
          <div class="doctor-info">
            <img :src="item.doctor.avatar || defaultAvatar" class="avatar" />
            <div class="info">
              <div class="name">
                <span class="doctor-name">{{ item.doctor.doctorName }}</span>
                <van-tag plain :color="getStatusColor(item.status)">{{ getStatusText(item.status) }}</van-tag>
              </div>
              <div class="title">{{ item.doctor.title }} | {{ item.doctor.department }}</div>
            </div>
          </div>
          <van-cell-group class="detail-info">
            <van-cell title="预约日期" :value="item.appointmentDate" />
            <van-cell title="预约时段" :value="item.appointmentTime" />
            <van-cell title="排队序号" :value="'第' + item.queueNum + '号'" />
            <van-cell title="患者姓名" :value="item.patientName" />
          </van-cell-group>
          <div class="actions" v-if="item.status === '0'">
            <van-button size="small" plain type="danger" @click.stop="cancelAppointment(item)">取消预约</van-button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <van-tabbar v-model="active" @change="onChange">
      <van-tabbar-item icon="home-o" to="/index/index">首页</van-tabbar-item>
      <van-tabbar-item icon="calendar-o" to="/yuyue/index">预约</van-tabbar-item>
      <van-tabbar-item icon="user-o" to="/mine/index">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  name: 'MyAppointment',
  data() {
    return {
      active: 2,
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      defaultAvatar: ''
    }
  },
  created() {
    this.checkLogin();
  },
  methods: {
    checkLogin() {
      var user = this.$tool.getUser();
      if (!user || !user.userId) {
        this.$dialog.alert({
          title: '提示',
          message: '请先进入预约页面完成登录'
        }).then(() => {
          this.$router.push('/yuyue/index');
        });
        return false;
      }
      return true;
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onChange(index) {
      console.log('切换到索引：', index);
    },
    loadData() {
      var user = this.$tool.getUser();
      if (!user || !user.userId) {
        this.loading = false;
        this.finished = true;
        return;
      }

      this.$http.get(this.$Api.appointmentList, {
        params: { userId: user.userId }
      }).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.data.code === 200) {
          this.list = res.data.data || [];
          this.finished = true;
        } else {
          this.$toast.fail(res.data.msg || '获取失败');
        }
      }).catch(() => {
        this.loading = false;
        this.refreshing = false;
        this.$toast.fail('网络错误');
      });
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.loadData();
    },
    getStatusText(status) {
      var map = {
        '0': '待就诊',
        '1': '已就诊',
        '2': '已取消',
        '3': '已过期'
      };
      return map[status] || '未知';
    },
    getStatusColor(status) {
      var map = {
        '0': '#1989fa',
        '1': '#07c160',
        '2': '#999',
        '3': '#999'
      };
      return map[status] || '#999';
    },
    goDetail(item) {
      this.$router.push('/mine/appointmentDetail?id=' + item.appointmentId);
    },
    cancelAppointment(item) {
      this.$dialog.confirm({
        title: '取消预约',
        message: '确定要取消该预约吗？'
      }).then(() => {
        var user = this.$tool.getUser();
        this.$http.post(this.$Api.appointmentCancel, null, {
          params: {
            appointmentId: item.appointmentId,
            userId: user.userId
          }
        }).then(res => {
          if (res.data.code === 200) {
            this.$toast.success('取消成功');
            this.onRefresh();
          } else {
            this.$toast.fail(res.data.msg || '取消失败');
          }
        }).catch(() => {
          this.$toast.fail('网络错误');
        });
      }).catch(() => {});
    }
  }
}
</script>

<style scoped>
.my-appointment-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 60px;
}
.van-tabbar-item--active {
  color: #3e97c1;
}
.empty {
  text-align: center;
  padding: 60px 0;
  color: #999;
}
.empty p {
  margin-top: 16px;
}
.appointment-item {
  background: #fff;
  margin: 10px;
  border-radius: 8px;
  overflow: hidden;
}
.doctor-info {
  display: flex;
  padding: 12px;
  border-bottom: 1px solid #eee;
}
.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 12px;
}
.info {
  flex: 1;
}
.name {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.doctor-name {
  font-size: 16px;
  font-weight: bold;
  margin-right: 8px;
}
.title {
  font-size: 12px;
  color: #666;
}
.detail-info .van-cell {
  padding: 8px 12px;
  font-size: 13px;
}
.actions {
  padding: 12px;
  text-align: right;
  border-top: 1px solid #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/mine/myAppointment.vue